import styled from 'styled-components';
import { ReactComponent as _CopyReferenceIcon } from 'styles/icons/copy-synced-icon.svg';
import { color } from 'styles/settings';
import { withModifiers } from 'utils/styles';

export const CopyReferenceIcon = styled(_CopyReferenceIcon)`
  height: 24px;
  width: 24px;
  color: ${color.neutral.plainBlack};
  cursor: pointer;
  margin-left: 20px;

  :hover {
    color: ${color.brand.gold};
  }

  ${withModifiers('disabled')`
    opacity: 0.4;
    cursor: not-allowed;
    :hover {
      color: initial;
    }
  `};
`;
